import "../../assets/styles/basic.scss";
import { useFormContext } from "../../features/auto-form/contexts/form-context";
import { useTranslate, translatedFormData } from "../../features/translation/";
import { Button, Loader } from "../../components";
import {
  AdditionalInformation,
  Ancillaries,
  GroupDetails,
  ProductSearch,
  ReferralSource,
  TermsAndConditions,
  ContactDetails,
} from "./sections";
import AccommodationPreferences from "./sections/accommodation-preferences/accommodation-preferences";
import Alert from "../../components/alert/alert";
import { formatSelectedDates } from "../../utils/format-date-input";
import send from "./services/send";
import { AxiosError } from "../../utils/custom-error";

import { useEffect, useState } from "react";

const GroupTravelForm = ({ market }) => {
  const {
    submit,
    isFormValid,
    isSubmitted,
    isLoading,
    abortLoading,
    errorMessage,
    displayErrors,
    errorRefs,
    getValues
  } = useFormContext();

  const { t } = useTranslate();
  const [selectedCustomerType, setSelectedCustomerType] = useState("");

  const handleSelectedCustomerTypeChange = (customerType) => {
    setSelectedCustomerType(customerType);
  };

  useEffect(() => {
    if (isSubmitted) {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  }, [isSubmitted]);

  const sendFormData = async (data) => {
    try {
      data.market = market || "se";
      const dates = data?.request?.dates;
      if (dates?.departure) {
        dates.departure =
          dates.type === "month"
            ? formatSelectedDates(dates.departure)
            : [{ start: dates.departure?.start, end: dates.departure?.end }];
      }

      const translatedData = translatedFormData(data, t);
      data.translatedRequest = translatedData.request;

      await send(data);
    } catch (error) {
      console.error(error);
      throw new AxiosError(error, t);
    }
  };

  const scrollToError = () => {
    displayErrors();
    let id = null;
    let top = null;
    for (let error of errorRefs) {
      const el = document.getElementById(error);
      if (el) {
        const rect = el.getBoundingClientRect();
        if (!top || rect.top < top) {
          id = error;
          top = rect.top;
        }
      }
    }
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: "smooth",
        block: "center",
        inline: "center",
      });
    }
  };

  
  if (isSubmitted) {
    return (
      <div className="page">
        <div className="container">
          <div className="row">
            <div className="col col-12">
              <h1 className="text lead xxxlarge bold">
                {t("confirmation.title")}
              </h1>
            </div>
          </div>
          <div className="row">
            <div className="col col-12">
              <div className="text base">
              <p>
              {t("confirmation.text")}<br /><br />
              <span dangerouslySetInnerHTML={{ __html: t("confirmation.text2") }} />
            </p>
            
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="page">
      {isLoading && <Loader onClick={() => abortLoading()} />}

      <div className="top-header"></div>
      <div className="top-header--rounded" />
      <div className="container">
        <div className="row">
          <div className="col col-12">
            <h1 className="text lead xxxlarge bold" style={{ color: "white" }}>
              {t("form.title")}
            </h1>
          </div>

        </div>
        <div className="row">
        <div className="col col-12 col-sm-8 col-md-8 ">
            <div
              className="text base"
              style={{ color: "white" }}
              dangerouslySetInnerHTML={{ __html: t("form.description") }}
            />
          </div>
        </div>
      </div>
      <ProductSearch
        market={market}
        onCustomerTypeChange={handleSelectedCustomerTypeChange}
      />

      <AccommodationPreferences />
      <Ancillaries />
      <GroupDetails />
      <ContactDetails customerType={selectedCustomerType} />
      <AdditionalInformation />
      <ReferralSource />
      <TermsAndConditions />

      <div className="container ">
        <div className="row ">
          <div className="col col-12 col-sm-4 col-md-3 ">
            <Button
              className="primary"
              //disabled={!isFormValid}
              onClick={() => {
                if (isFormValid) {
                  submit(sendFormData);
                } else {
                  scrollToError();
                }
              }}
              style={{
                minWidth: "100%",
                padding: "var(--space-3)",
                zIndex: "1000",
              }}
            >
              {t("input.button.submit")}
            </Button>
          </div>
        </div>
        <div className="row">
          <div className="col col-12">
            {errorMessage && (
              <Alert type="error" label="">
                {errorMessage}
              </Alert>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default GroupTravelForm;
/*/*
{
  }
        <div  className='form-footer'>
             <div className='page' style={{paddingTop:"var(--space-6)", paddingBottom:"var(--space-6)"}}>
 
                    <div  style={{ backgroundColor:"var(--color-theme-surface)",border:"1px solid var(--color-achromatic-base-400)", borderRadius:"var(--corner-rounded-4)", padding: "var(--space-4)", maxWidth:"100vw"}}>
                        <div className='container '>
                            <div className='row '>
                                <div className='col col-12 '>
                                 <RequestSummary /> 
                                </div>
                            </div>
                            <div className='row ' style={{marginBottom:"0"}}>
                                <div className='col col-12 col-sm-4 col-md-3 '>
                                    <Button className="primary" onClick={submit} style={{minWidth:"100%", padding:"var(--space-3)"}}>Submit request</Button>
                                </div>
                            </div>
                        </div>

                    </div>
         
                            
                   
         </div>
         
         </div>
     {
      
      
              {!isFormValid && (
          <div className="row">
            <div className="col col-12">
              <Alert type="warning" label={t("error.missingFieldsTitle")}>
                <div>
                  <div
                    className="text base"
                    dangerouslySetInnerHTML={{
                      __html: t("error.missingFieldText"),
                    }}
                  />
                  <Button
                    label={t("input.button.displayMissingValues")}
                    style={{ margin: "var(--space-4) 0" }}
                    className="small ghost"
                    onClick={() =>
                    scrollToError()
                    }
                    />
                  </div>
                </Alert>
              </div>
            </div>
          )}
      
      

}      */
